// 상품 리스트 & 대량 상품 등록에서 공통으로 사용하는 복사 관련 로직을 정의합니다.
import { i18n } from '@/main';
import {OptColumn} from '@/pro/types';
import {Row} from '@/pro/types/tui-grid';
import {throwWindowPopup} from '@/pro/helpers/popup';
import {PLAN_TYPE} from '@/pro/const/contents/mall';
import {centerWinOptions} from '@/utils/commonUtils';

export const getCopyGridColumn = (): OptColumn => {
  return {
    header: 'COMMON_COPY',
    name: 'copy',
    align: 'center',
    minWidth: 50,
    formatter: ({ row }) => {
      const canCopied = row.applyStatusType !== 'REGISTRATION_READY' && row.optionType !== 'MAPPING';
      const isNotSale = row.saleSettingStatusType === 'PROHIBITION_SALE' && row.parentMallProductNo !== 0;

      if (!canCopied || isNotSale) return '-';

      const planType = row.mallServicePlan === PLAN_TYPE.PRO ? PLAN_TYPE.PRO : PLAN_TYPE.PREMIUM;
      const url = `/product/popup/copyMallProduct?mallNo=${row.mallNo}&mallProductNo=${row.mallProductNo}&saleStatusType=${row.saleStatusType}&itemYn=${row.isItem ? 'Y' : 'N'}&planType=${planType}`;
      return `<a href="javascript:onclick=window.open('${url}','copyMallProductWin','${centerWinOptions(888, 610)}')">${i18n.t('COMMON_COPY')}</a>`;
    },
  };
};

export const openCopyProductPopup = ({
  applyStatusType,
  saleStatusType,
  optionType,
  mallProductNo,
  mallNo,
  isItem,
}: Row) => {
  const canCopied = applyStatusType !== 'REGISTRATION_READY' && optionType !== 'MAPPING';
  if (!canCopied) return; // onItemClicked 는 해당 셀이 클릭 가능한 상태인지, 불가능한 상태인지 특정할 수 없어서 여기서 한번 더 거른다.

  throwWindowPopup('CopyProduct', { mallProductNo, mallNo, isItem, saleStatusType }, 'md', () => null);
};
